/*
*###############################################################################
*Module Name                   : DPTagPop.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useState } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal, Pagination } from "reactstrap"
import MetaTags from 'react-meta-tags'
import "../../assets/scss/datatables.scss"
import BC from '../../assets/images/support/bc.png'
import ReactPaginate from "react-paginate";
import { useEffect } from "react";


const DPTxnProductSIH = (props) => {

    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const indexOfLastPost = pageNo * pageSize
    const indexOfFirstPost = indexOfLastPost - pageSize
    const currentGroupRows = props.Data.slice(indexOfFirstPost, indexOfLastPost)

    useEffect(() => {
        setPageNo(1)
    }, [props.isOpen])

    const handlePageClick = (event) => {
        setPageNo(event.selected + 1);
    };

    return (
        <div>
            <Modal
                size="md"
                isOpen={props.isOpen}
                toggle={props.toggle}
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">{props.SubTitle} </CardTitle>
                                    <Row>
                                        <Col className="col-12">
                                            <div className="table-responsive" style={{ maxHeight: '500px' }}>
                                                <table className="table table-bordered  table-sm rounded  mb-0">
                                                    <thead className="thead-light">
                                                        <tr>
                                                            <th>Product Code</th>
                                                            <th>Product Desc</th>
                                                            <th>Currenct SIH</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentGroupRows.map((item, index) => {
                                                            return (
                                                                <tr key={index} className="p-0 m-0">
                                                                    <td>
                                                                        <h5 className="font-size-12 mb-0">{item.product}</h5>
                                                                    </td>
                                                                    <td>
                                                                        <h5 className="font-size-12 mb-0">{item.description}</h5>
                                                                    </td>
                                                                    <td>
                                                                        <h5 className="font-size-12 mb-0">{item.sih}</h5>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <ReactPaginate
                                            previousLabel={'Previous'}
                                            nextLabel={'Next'}
                                            breakLabel={'...'}
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            pageCount={Math.ceil(props.Data.length / pageSize)}
                                            pageRangeDisplayed={2}
                                            onPageChange={handlePageClick}
                                            forcePage={pageNo - 1}
                                            renderOnZeroPageCount={null}
                                            activeClassName={'active'}
                                            activeLinkClassName={'page-link'}
                                            containerClassName={'pagination justify-content-end pagination-sm'}

                                        />
                                    </Row>
                                    {/* <Row>
                                        <Col sm={6} md={2} className="mb-4-sm">
                                            <Button
                                                color="danger"
                                                className="btn-block waves-effect waves-light"
                                                onClick={props.toggle}
                                            >
                                                Close
                                            </Button>
                                        </Col>
                                        <Col sm={6} md={2} className="mb-4-sm">
                                            <Button
                                                color="primary"
                                                className="btn-block waves-effect waves-light"
                                                onClick={props.toggle}
                                            >
                                                Continue
                                            </Button>
                                        </Col>
                                    </Row> */}
                                    <Row>
                                        Click Continue to proceed with the transaction or Close to cancel to stop the transaction.
                                    </Row>
                                    <Row className="justify-content-center mt-3">
                                        <Col sm={2} md={2} className="mb-4 mb-sm-0 text-center"></Col>
                                        <Col sm={4} md={4} className="mb-4 mb-sm-0 text-center">
                                            <Button
                                                color="primary"
                                                className="btn-block waves-effect waves-light"
                                                onClick={props.continueOnClick}
                                            >
                                                Continue
                                            </Button>
                                        </Col>
                                        <Col sm={4} md={4} className="mb-4 mb-sm-0 text-center">
                                            <Button
                                                color="danger"
                                                className="btn-block waves-effect waves-light"
                                                onClick={props.toggle}
                                            >
                                                Close
                                            </Button>
                                        </Col>
                                        <Col sm={2} md={2} className="mb-4 mb-sm-0 text-center"></Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </Modal>
        </div>
    );
}

export default DPTxnProductSIH;